module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-category1.542385c0.svg";